import { render, staticRenderFns } from "./PreparePackageBuyerDetail.component.vue?vue&type=template&id=c9f0e802&scoped=true&"
import script from "./PreparePackageBuyerDetail.component.vue?vue&type=script&lang=js&"
export * from "./PreparePackageBuyerDetail.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f0e802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
